import { render, staticRenderFns } from "./QuickAccessCard.vue?vue&type=template&id=f236f798&scoped=true&"
import script from "./QuickAccessCard.vue?vue&type=script&lang=js&"
export * from "./QuickAccessCard.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccessCard.vue?vue&type=style&index=0&id=f236f798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f236f798",
  null
  
)

export default component.exports